module.exports = __webpack_public_path__ + "static/media/co.e7064ce5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/weather/svg/co.jpg
// module id = 771
// module chunks = 0